import { useSearchParams } from "react-router";

import { CircleIcon } from "@radix-ui/react-icons";

import type { ProductSearchSortingOption } from "~/lib/app.types";
import { cn } from "~/lib/ui";

import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "../ui/command";

export interface SortPropsType {
  title?: string;
  options: ProductSearchSortingOption[];
  currentOption?: string | null | undefined;
  setFilterValue?: (value: string | undefined) => void;
}

export function Sort({
  options,
  currentOption,
  setFilterValue,
}: SortPropsType) {
  const [searchParams, setSearchParams] = useSearchParams();
  const $sort = currentOption ?? searchParams.get("sort") ?? undefined;

  return (
    <>
      <div className="w-full p-0">
        <Command className="bg-transparent" value={$sort}>
          <CommandList>
            <CommandGroup>
              {options.map(option => {
                const isSelected = option.id === $sort;
                return (
                  <CommandItem
                    key={option.id}
                    className="px-4 py-3"
                    onSelect={() => {
                      setFilterValue?.(option.id) ??
                        setSearchParams(
                          prev => {
                            prev.set("sort", option.id);
                            prev.delete("page");
                            return prev;
                          },
                          {
                            preventScrollReset: true,
                          },
                        );
                    }}
                  >
                    <div
                      className={cn(
                        "mr-2 flex h-4 w-4 items-center justify-center rounded-full border border-neutralalpha-7",
                        isSelected
                          ? "bg-accent-9 text-white"
                          : "bg-neutral-2 [&_svg]:invisible",
                      )}
                    >
                      <CircleIcon className={cn("h-4 w-4")} />
                    </div>
                    <span className="text-base font-semibold text-neutral-11">
                      {option.label}
                    </span>
                  </CommandItem>
                );
              })}
            </CommandGroup>
            {$sort && (
              <>
                <CommandSeparator />
                <CommandGroup>
                  <CommandItem
                    onSelect={() =>
                      setFilterValue?.(undefined) ??
                      setSearchParams(
                        prev => {
                          prev.delete("sort");
                          prev.delete("page");
                          return prev;
                        },
                        {
                          preventScrollReset: true,
                        },
                      )
                    }
                    className="justify-center text-center"
                  >
                    Clear
                  </CommandItem>
                </CommandGroup>
              </>
            )}
          </CommandList>
        </Command>
      </div>
    </>
  );
}
